<template>
  <div
    class="list-item"
    :class="{ active: type === 'active', model }"
    @click="itemClick"
  >
    <div class="image" v-lazy:background-image="item.image" :key="item.image">
      <div v-if="item.socialNetwork === 1" class="ins-user-icon"></div>
      <div v-if="item.socialNetwork === 2" class="fb-page-user-icon"></div>
      <div v-if="item.socialNetwork === 3" class="fb-group-user-icon"></div>
      <div v-if="item.socialNetwork === 4" class="tw-user-icon"></div>
    </div>
    <div class="select-main-container">
      <div class="username-text">{{ item.username }}</div>
      <div class="des-text" v-if="item.description">{{ item.description }}</div>
    </div>
    <div class="icon normal" v-if="type === 'normal'"></div>
    <div class="icon select" v-if="type === 'select'"></div>
    <div class="icon forbid" v-if="type === 'forbid'"></div>
  </div>
</template>
<script>
export default {
  name: "UnlimitedAutopostSelectListItemComponent",
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "normal",
    },
    model: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      removeModal: false,
      showSelectModal: false,
    };
  },
  methods: {
    itemClick() {
      this.$emit("itemClick", this.item);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.list-item {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  &.model {
    height: 56px;
    padding: 0 23px;
    .select-main-container {
      text-align: start;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .username-text {
        font-size: 15px;
      }
      .des-text {
        font-size: 13px;
        margin-top: 4px;
      }
    }
  }
  &.active {
    background: #f0f0f0;
    border-right: 3px solid #e72955;
  }
  .image {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    position: relative;
  }
  .select-main-container {
    display: flex;
    flex-direction: column;
    height: 36px;
    margin-left: 10px;
    flex: 1;
    line-height: 1;
    justify-content: space-between;
    .username-text {
      font-size: 16px;
      font-weight: 500;
    }
    .des-text {
      font-size: 14px;
      color: @font-color-gray;
    }
  }
  .icon {
    width: 40px;
    height: 40px;
    background-size: contain;
    background-position: center;
    &.normal {
      background-image: url("../../../../public/images/common/Normal@3x.png");
    }
    &.select {
      background-image: url("../../../../public/images/common/Select@3x.png");
    }
    &.forbid {
      background-image: url("../../../../public/images/common/Normal_Gray@3x.png");
    }
  }
}
</style>
